// extracted by mini-css-extract-plugin
export default {"container":"ProductModelDetails__container___Pm90m","fullWidthTab":"ProductModelDetails__fullWidthTab___QdFai"};